import {MutationTree} from "vuex";
import * as moment from 'moment';
import User from "../ts/User";
import UserRoles from "../ts/UserRoles";
import AjaxError from "../../../components/helpers/AjaxError";
import Role from "../ts/Role";

export const mutations: MutationTree<any> = {

    setUsersLoading(state: any, payload: boolean) {
        state.usersLoading = payload;
        state.usersLoadError = null;
    },

    setUsers(state: any, users: Array<User>) {
        state.usersCacheExpires = moment().add(15, 'minutes');
        state.users = users;
    },

    updateUsers(state: any, user: User) {
        const index = state.users.findIndex((item: User) => item.id === user.id);
        state.users.splice(index, 1, user);
    },

    deleteUser(state: any, id: number) {
        const index = state.users.findIndex((user: User) => user.id === id);
        state.users.splice(index, 1);
    },

    createRole(state: any, role: Role) {
        state.roles.push(role);
    },

    updateRole(state: any, role: Role) {
        const index = state.roles.findIndex((item: Role) => item.id === role.id);
        state.roles.splice(index, 1, role);
    },

    deleteRole(state: any, id: number) {
        const index = state.roles.findIndex((role: Role) => role.id === id);
        state.roles.splice(index, 1);
    },

    setUserUpdating(state: any, payload: boolean) {
        state.userUpdating = payload;
    },

    setUserRole(state: any, userRoles: UserRoles) {

        let user = state.users.find((user: User) => {
            return userRoles.userId === user.id;
        });

        if (user) {
            user.roles = userRoles.roles
        } else {
            throw Error('User not found with id ' + userRoles.userId);
        }
    },

    setRolesLoading(state: any, payload: boolean) {
        state.rolesLoading = payload;
    },

    setRoles(state: any, payload: Array<Object>) {
        state.rolesLoadedTime = moment().format('X');
        state.roles = payload;
    },

    setPermissions(state: any, payload: Array<Object>) {
        state.permissions = payload;
    },

    clearUsers(state: any) {
        state.users = [];
    },

    setError(state: any, error: AjaxError) {
        state.usersLoadError = error;
    },

    setPendingInvitationsLoading(state: any, payload: boolean) {
        state.pendingInvitationsLoading = payload;
    },

    setPendingInvitations(state: any, payload: Array<any>) {

        payload.forEach(function (invitation) {
            invitation.created = moment.utc(invitation.created_at).local().format('MMMM Do, YYYY');

            // Add some extra data for expiration rendering
            let hours = moment.utc(invitation.created_at).add(7, 'days')
                .diff(moment.utc(), 'hours');

            if (hours < 0) {
                invitation.expired = true;
                invitation.expires = 0;
            } else {
                invitation.expired = false;
                invitation.expires = moment.duration(hours, "hours").humanize();
            }

        });

        state.pendingInvitations = payload;
    },

    cancelPendingInvitation(state: any, id: number) {

        let index = state.pendingInvitations.findIndex((invite: any) => {
            return id === invite.id;
        });

        state.pendingInvitations.splice(index, 1);

    }
};
